import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { MainLayout } from 'components/Layout/MainLayout';
import { useAppDispatch, useAppSelector } from 'store';
import {
  loadPurchasePlansItem,
  savePurchasePlansItem,
  savePurchasePlansItemDraft,
} from 'store/slices/purchasePlans/actions';
import {
  PurchasePlansItem,
  PurchasePlansItemRequest,
} from 'store/slices/purchasePlans/interfaces';
import { DeepPartial } from 'types/utils';

import { PurchasePlansForm } from './components/PurchasePlansForm';
import { mapValuesToForm } from './components/PurchasePlansForm/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { item } = useAppSelector(state => state.purchasePlans);
  const isCorrectItem = item?.id === Number(id);

  React.useEffect(() => {
    dispatch(loadPurchasePlansItem(id));
  }, [id]);

  const onSubmit = (values: PurchasePlansItemRequest) => {
    setIsLoading(true);
    const newItem = { ...values, id: item?.id };
    dispatch(savePurchasePlansItem(newItem))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'План закупок успешно обновлен',
        });
        navigate('/purchasePlans');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveAsDraft = (values: DeepPartial<PurchasePlansItem>) => {
    setIsLoading(true);
    dispatch(savePurchasePlansItemDraft({ ...values, id: item?.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'План закупок успешно обновлен',
        });
        navigate('/purchasePlans');
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {isCorrectItem && (
        <PurchasePlansForm
          onSubmit={onSubmit}
          isDraft={item.status === 'draft'}
          isLoading={isLoading}
          defaultValues={mapValuesToForm(item)}
          onSaveAsDraft={onSaveAsDraft}
        />
      )}
    </MainLayout>
  );
};
